export default __webpack_public_path__ + "images/pdf.0f709fd47718d9e517b15195203f4fea.svg";